import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class DirectAccessGuard  {
  constructor(public router: Router,) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if(this.router.url === '/') {
      this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}
